// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CASHIER_API_01,
  COMMON_API_01,
  CASHIER_API_02,
  CASHIER_API_06,
} from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  Alert,
  Pagination,
  CardMedia,
} from "@mui/material";
import Header from "../../components/common/Header";
import { useStyles } from "../../assets/styles/Theme";
import UberOrderAside from "../../components/uber/UberOrderAside";
import UberOrderItemCard from "../../components/uber/UberOrderItemCard";
import {
  CON_STATUS_ACTIVE,
  CON_CAT_TYPE_RESTAURANT,
  CON_STATUS_PENDING,
  CON_STATUS_NO,
  CON_STATUS_RETURN,
  CON_IS_CASHIER_YES,
  CON_STATUS_RECEIVED,
} from "../../utils/sys/Constants";
import ubereatslogo from "../../assets/images/ubereatslogo.png";
import uber_states from "../../store/store";
import { uber_orders } from "../../store/store";

// imports section End

export default function ViewUberorders() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  const [value, setValue] = useState("All");
  const [placedorderItems, setPlacedorderItems] = useState([]);
  const [orderStates, setOrderstates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetails, setOrderDetails] = useState({ items: [] });
  const [OrderBillDetails, setOrderBillDetails] = useState({ items: [] });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  // Handlers start
  const itemsPerPage = 15; // Number of items per page

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCurrentPage(1);
  };

  const filterPlacedOrders = (orderType) => {
    const filteredOrders = uber_orders.filter(order => 
      order.data.some(item => item.order.state === orderType)
    );
    return orderType === "All" ? uber_orders : filteredOrders;
  };

  const handleViewOrder = async (order) => {
    setSelectedOrder(order);
  };

  // Filtered items based on selected tab
  const filteredItems = filterPlacedOrders(value);

  // Pagination logic for filtered items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    fetchOrderTypes();
    fetchPlacedOrders();
  }, []);
  // Handlers end

  // API calls start
  const fetchOrderTypes = async () => {
    try {
      setOrderstates(uber_states);
    } catch (error) {
      setError(error);
    }
  };

  const fetchPlacedOrders = async () => {
    try {
      setPlacedorderItems(uber_orders);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  // API calls end

  return (
    <Box sx={styles.root}>
      <Grid container sx={styles.height}>
        <Grid xs={12} sm={12} md={8} lg={8} xl={8} sx={styles.screen_content}>
          <Box
            sx={{
              backgroundColor: theme.palette.background.paper,
              width: "100%",
              padding: "12px 16px 0 16px",
              borderBottom: `2px solid ${theme.palette.stroke.main}`,
              boxShadow: 1,
            }}
          >
            <Header />
            <Box sx={styles.tabs_container}>
              <Tabs
                value={value}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                aria-label="primary tabs example"
                sx={{ flexGrow: 1 }}
              >
                <Tab value="All" label="All" />
                {orderStates.map((type) => (
                  <Tab
                    key={type.ORDERSTATECODE}
                    value={type.ORDERSTATE}
                    label={type.ORDERSTATE}
                  />
                ))}
              </Tabs>
              <CardMedia
              component="img"
              src={ubereatslogo}
              sx={{
                maxHeight: "40px",
                maxWidth: "40px",
                minHeight: "40px",
                minWidth: "40px",
              }}
            />
            </Box>
          </Box>

          <Box sx={styles.cards_container}>
            <Grid container spacing={4} sx={styles.po_card_item}>
              {loading ? (
                <Box sx={styles.progress_circular}>
                  <CircularProgress />
                </Box>
              ) : error ? (
                <Alert severity="error">
                  Error fetching data: {error.message}
                </Alert>
              ) : (
                currentItems.map((placedorderItem, index) => (
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={4} key={index}>
                    <UberOrderItemCard
                      placedorderItem={placedorderItem}
                      onViewOrder={handleViewOrder}
                      order={selectedOrder}
                      details={orderDetails}
                      billDetails={OrderBillDetails}
                      setLoading={setLoading}
                      loading={loading}
                    />
                  </Grid>
                ))
              )}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                pt: 2,
              }}
            >
              <Pagination
                count={Math.ceil(filteredItems.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          </Box>
        </Grid>

        <Grid container xs={12} sm={12} md={4} lg={4} xl={4}>
          <UberOrderAside
            order={selectedOrder}
            details={orderDetails}
            billDetails={OrderBillDetails}
            // placedorderItem={placedorderItem}
            onViewOrder={handleViewOrder}
            setLoading={setLoading}
            loading={loading}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
